// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PreviewAlert_wrapper__rtIB9"};